import React from "react";
import { useCartContext, useProductsContext } from "../../contexts";
import PriceDetailsCard from "./PriceDetailsCard";
import { notify } from "../../../utils/utils";
import Config from '../../../config/index'
import commonObj from '../../../utils/Common';
import {myDateFormat} from '../../../utils/utils';

const SummaryCard = ({ setShowModal }) => {
  const { addressList, currentAddress } = useProductsContext();
  const { cart, totalPriceOfCartProducts, actualPriceOfCart, adminFee, imgurl, setDeliveryDate, deleteProductFromCart, disableCart } =
    useCartContext();
  const totalItems = cart.length; //cart.reduce((acc, { qty }) => acc + qty, 0);
  console.log('cart', cart)

  // currency setting, category wise
  const CurrencyType = (catId) =>{
      return (catId===39) ? commonObj.getCurrency('yuan') 
                          : (catId===41) ? commonObj.getCurrency('doller') 
                          : commonObj.getCurrency('mn')
   }
  const cartCurrency = cart.length > 0 ? CurrencyType(cart[0].productCategory) : commonObj.getCurrency('mn');


  return (
    <section className="py-3 md:py-7 px-5 md:px-7 lg:px-12 rounded-md shadow-sm bg-white/[0.7] flex flex-col gap-5 w-full h-min summary-sec">
      <h1 className="text-2xl font-bold">{commonObj.getLabel('Order_Summary')}</h1>

      {cart.map((item) => (
        <div
          className="flex flex-col gap-2 shadow-sm px-4 py-2 rounded-sm "
          key={item.id}
        >
          <div className="flex  items-center flex-wrap gap-2 w-full cart-1">
            <div className="flex flex-1 items-center gap-2">
              <div className=" bg-black/[0.075] h-16 w-16 rounded-md flex items-center">
                <img src={imgurl+item.productImage} alt="" className="object-fit w-full" />
              </div>
              <div className="">
                <h2>{item.productName}</h2>
                <span>{cartCurrency}{item.proposedPrice}</span>
                {/* <span className="text-sm text-gray-500 line-through px-2">
                {commonObj.getCurrency('mn')}{item.productPrice}
                </span> */}
              </div>
            </div>
            <div className="text-lg">x{item.productQuantity}</div>
          </div>
          <div className=" flex flex-1 items-center gap-2 cart-2">
          <button
            className="btn-rounded-secondary  text-xs sm:text-sm mt-2 max-w-xs disabled:cursor-not-allowed"
            disabled={disableCart}
            onClick={() => deleteProductFromCart(item.id)}
          >
            {commonObj.getLabel('Remove_from_Bag')}
          </button>
          </div>
        </div>
      ))}

      <hr />
      <PriceDetailsCard
        totalItems={totalItems}
        actualPriceOfCart={actualPriceOfCart}
        totalPriceOfCartProducts={totalPriceOfCartProducts} 
        adminFee={adminFee}
        cartCurrency={cartCurrency}
      />

      <hr />
      <div className="flex justify-between items-center cart-3">
        <p className=" text-gray-600">{commonObj.getLabel('Total')} </p>
        <p className="text-2xl">{cartCurrency}{(parseFloat(totalPriceOfCartProducts)+parseFloat(adminFee)).toFixed(2)}</p>
      </div>

      <div className="w-full py-2   flex gap-4 items-center cart-4">
        <button
          onClick={() => {
            if (
              addressList.length === 0 ||
              Object.keys(currentAddress).length === 0
            ) {
              notify("warn", commonObj.getLabel('Please_Select_or_Add_ddress'));
            } else {
              let ddd = document.getElementById('deliveryDate').value
              if(!ddd){
                notify("warn", commonObj.getLabel('Delivery_Date_missing'));
              }else{
                setDeliveryDate( myDateFormat(document.getElementById('deliveryDate').value, false, true) )
                setShowModal(true);
              }
            }
          }}
          className="btn-rounded-primary rounded-full flex items-center gap-2 md:text-sm lg:text-base"
        >
         {commonObj.getLabel('Place_Order')} 
        </button>
      </div>
    </section>
  );
};

export default SummaryCard;
